(function(){
if(!document.body||!document.body.classList.contains('tpl-collection'))return;
var nav=document.querySelector('[data-vxnav]');if(!nav)return;
var eD=document.querySelector('[data-vxdic]'),eT=document.querySelector('[data-vxdictipo]');
if(!eD||!eT)return;
var DIC=JSON.parse(eD.textContent),PT=JSON.parse(eT.textContent);
var TIPOS=(function(){for(var i=0;i<DIC.length;i++)if(DIC[i].k==='tipo')return DIC[i].o;return[]})();
var CARET='<span class="svg-wrapper"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" fill="currentColor"></path></svg></span>';
var CHECK='<svg width="16" height="16" viewBox="0 0 16 16"><rect width="16" height="16" fill="none" stroke="currentColor"/></svg><div class="svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-checkmark" viewBox="0 0 12 9"><path fill="currentColor" fill-rule="evenodd" d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z" clip-rule="evenodd"/></svg></div>';
var grid=document.querySelector('.product-grid');
var boxT=nav.querySelector('[data-vxtipos-lista]'),boxG=nav.querySelector('[data-vxgrupos]');
var tipo='',mark={},carregado=false;
function itens(){return grid?[].slice.call(grid.querySelectorAll('li')):[]}
function tags(li){var e=li.matches('[data-vxtags]')?li:li.querySelector('[data-vxtags]');return e?(e.getAttribute('data-vxtags')||'').split(','):[]}
function tem(t,tg){return t.indexOf(tg)>=0}
var MATG=['filamento','resina','po-plastico','po-metalico','pellet'];
function bateGrupo(t,k){
 if(k==='material')return MATG.some(function(x){return tem(t,x)});
 if(k==='acessorio')return t.some(function(x){return x.indexOf('acessorio')===0});
 return tem(t,k)}
function passa(t,pula){
 if(tipo&&!tem(t,tipo))return false;
 if(pula!=='grupo'){var gs=mark['grupo']||[];
  if(gs.length){var okg=false;for(var z=0;z<gs.length;z++)if(bateGrupo(t,gs[z])){okg=true;break}
   if(!okg)return false}}
 for(var k in mark){if(k===pula||k==='grupo')continue;var v=mark[k]||[];if(!v.length)continue;
  var ok=false;for(var i=0;i<v.length;i++)if(tem(t,v[i])){ok=true;break}
  if(!ok)return false}
 return true}
var VXIDX=null,VXIDXOK=false;function idx(){return VXIDXOK?VXIDX:false}function carregaIdx(cb){try{var c=sessionStorage.getItem('vxidx3');if(c){VXIDX=JSON.parse(c).map(function(s){return String(s).split(',')});VXIDXOK=VXIDX.length>0;cb();return}}catch(e){}var base='';var ss=document.getElementsByTagName('script');for(var i=0;i<ss.length;i++){var s=ss[i].src||'';if(s.indexOf('voxel-filtro')>=0){base=s.replace(/voxel-filtro\.js.*$/,'');break}}if(!base){VXIDXOK=false;cb();return}var x=new XMLHttpRequest();x.open('GET',base+'vxidx.json?v='+Math.floor(Date.now()/600000),true);x.onload=function(){try{var a=JSON.parse(x.responseText);VXIDX=a.map(function(s){return String(s).split(',')});VXIDXOK=VXIDX.length>0;try{sessionStorage.setItem('vxidx3',x.responseText)}catch(e){}}catch(e){VXIDXOK=false}cb()};x.onerror=function(){VXIDXOK=false;cb()};x.send()}
function todasTags(){var i=idx();if(i&&i.length)return i;return itens().map(function(li){return tags(li)})}
function conta(g,tg){var n=0;todasTags().forEach(function(t){if(tem(t,tg)&&passa(t,g))n++});return n}
function contaTipo(tg){var n=0,sv=tipo;tipo='';todasTags().forEach(function(t){if(tem(t,tg))n++});tipo=sv;return n}
function bloco(rot,itensHtml){
 return '<details class="facets__disclosure-vertical js-filter vxg" open>'+
  '<summary class="facets__summary caption-large focus-offset"><div><span class="facets__summary-label">'+rot+'</span>'+CARET+'</div></summary>'+
  '<div class="facets__display-vertical"><fieldset class="facets-wrap parent-wrap facets-wrap-vertical">'+
  '<ul class="facets-layout facets-layout-list facets-layout-list--text facets__list--vertical list-unstyled" role="list">'+itensHtml+'</ul></fieldset></div></details>'}
function caixa(id,tg,gr,rot,n,marcada){
 return '<li class="facets__item list-menu__item"><label for="'+id+'" class="facets__label facet-checkbox">'+
  '<input type="checkbox" id="'+id+'" data-tg="'+tg+'" data-gr="'+gr+'"'+(marcada?' checked':'')+'>'+CHECK+
  '<span class="facet-checkbox__text"><span class="facet-checkbox__text-label">'+rot+'</span> ('+n+')</span></label></li>'}
function qsTags(){
 var q=[];
 for(var k in mark)(mark[k]||[]).forEach(function(t){if(q.indexOf(t)<0)q.push(t)});
 return q.length?'?f='+encodeURIComponent(q.join(',')):''}
function linkTipo(t,rot,on){
 return '<li class="facets__item list-menu__item"><a class="facets__label facet-checkbox'+(on?' is-on':'')+'" href="'+(t?'/collections/'+t:'/collections/all')+qsTags()+'">'+
  '<input type="checkbox" tabindex="-1" aria-hidden="true"'+(on?' checked':'')+' onclick="return false">'+CHECK+
  '<span class="facet-checkbox__text"><span class="facet-checkbox__text-label">'+rot+'</span></span></a></li>'}
function listaTipos(){
 var h=linkTipo('','Todos',!tipo);
 TIPOS.forEach(function(o){h+=linkTipo(o.t,o.n,tipo===o.t)});
 boxT.innerHTML=bloco('Tipo de produto',h)}
function barra(){
 var b=document.querySelector('[data-vxbarra]');
 if(b)return b;
 var busca=document.querySelector('.vxbusca');
 var alvo=document.querySelector('.facets-vertical-sort');
 b=document.createElement('div');b.className='vxbar';b.setAttribute('data-vxbarra','');
 if(busca&&busca.parentElement)busca.parentElement.insertBefore(b,busca.nextSibling);
 else{
  var solo=alvo||document.getElementById('ProductGridContainer')||document.querySelector('.collection')||document.querySelector('main');
  if(!solo||!solo.parentElement)return null;
  b.classList.add('vxbar--solo');solo.parentElement.insertBefore(b,solo)}
 if(alvo)alvo.classList.add('vxsort');
 if(!document.querySelector('[data-vxchips]')){
  var ch=document.createElement('div');ch.className='vxchips';ch.setAttribute('data-vxchips','');ch.hidden=true;
  if(alvo)alvo.insertBefore(ch,alvo.firstChild);
  else b.parentElement.insertBefore(ch,b.nextSibling)}
 return b}
function susp(g,sel){
 var li='';
 g.o.forEach(function(o){li+=caixa('vxf-'+g.k+'-'+o.t,o.t,g.k,o.n,conta(g.k,o.t),sel.indexOf(o.t)>=0)});
 var rot=sel.length?g.r+' ('+sel.length+')':g.r;
 return '<details class="vxbar__g'+(sel.length?' is-on':'')+'" data-vxg="'+g.k+'">'+
  '<summary class="vxbar__s"><span class="vxbar__r">'+rot+'</span>'+CARET+'</summary>'+
  '<div class="vxbar__p"><ul class="vxbar__l list-unstyled" role="list">'+
  '<li class="facets__item list-menu__item"><label class="facets__label facet-checkbox vxbar__todos" for="vxf-'+g.k+'-todos">'+
  '<input type="checkbox" id="vxf-'+g.k+'-todos" data-gr="'+g.k+'" data-todos="1"'+(sel.length?'':' checked')+'>'+CHECK+
  '<span class="facet-checkbox__text"><span class="facet-checkbox__text-label">Todas</span></span></label></li>'+
  li+'</ul></div></details>'}
var EIXOS=[{k:'tipo',n:'Por Tipo de Produto'},{k:'marca',n:'Por Marca'},{k:'maquina',n:'Por Máquina'}];
var eixo='tipo';
var EIXOPERM={tipo:['marca','maquina'],marca:['grupo','tipomat','marca'],maquina:['grupo','maquina']};
var EIXOFIXO={grupo:1,tipomat:1,marca:1,maquina:1};
function migra(destino){
 var p=EIXOPERM[destino]||[],n={},prefixa=destino!=='tipo';
 for(var k in mark){
  var v=(mark[k]||[]).slice();if(!v.length)continue;
  var base=k.indexOf('g_')===0?k.slice(2):k;
  if(EIXOFIXO[base]){if(p.indexOf(base)>=0)n[base]=v;continue}
  n[(prefixa?'g_':'')+base]=v}
 if((n['marca']||[]).length>1)n['marca']=[n['marca'][0]];
 if((n['maquina']||[]).length>1)n['maquina']=[n['maquina'][0]];
 return n}
function tecDaMaquina(){
 var mq=(mark['maquina']||[])[0];if(!mq)return;
 var el=document.querySelector('[data-vxblocos]');if(!el)return;
 var B=window.__vxB||(window.__vxB=JSON.parse(el.textContent));
 (B['maquina']||[]).forEach(function(o){if(o.t===mq&&o.tec)tec=o.tec})}
function tipoDaUrl(){
 var seg=(location.pathname.split('/collections/')[1]||'').split('/')[0].split('?')[0];
 return TIPOS.some(function(o){return o.t===seg})?seg:''}
function eixos(){
 var b=barra();if(!b)return;
 b.hidden=false;
 b.innerHTML=EIXOS.map(function(e){
  return '<button type="button" class="vxeixo'+(eixo===e.k?' is-on':'')+'" data-vxeixo="'+e.k+'">'+e.n+'</button>'}).join('')+'<a class="vxbar__pm'+(location.pathname==='/collections/promocao'?' is-on':'')+'" href="/collections/promocao">Em promoção</a>';
 [].forEach.call(document.querySelectorAll('.vxeixo__x[data-eixo]'),function(z){
  var k=z.getAttribute('data-eixo');if(k==='produto')k='tipo';
  z.classList.toggle('is-on',k===eixo)})}
var TECS=[{t:'equipamento-filamento',n:'Impressoras 3D FDM'},{t:'equipamento-resina',n:'Impressoras 3D de Resina'},
{t:'equipamento-resina-dental',n:'Impressoras 3D de Resina Dental'},{t:'equipamento-sls',n:'Impressoras 3D SLS'},
{t:'equipamento-metal',n:'Impressoras 3D de Metal (SLM)'},{t:'equipamento-pellet',n:'Impressoras de Pellet'},
{t:'equipamento-injecao',n:'Injetoras de Bancada'},{t:'equipamento-acabamento-sls-fdm',n:'Pós-processamento'}];
var tec='';
function blocosMaquina(){
 var el=document.querySelector('[data-vxblocos]');if(!el||!grid)return;
 var B=window.__vxB||(window.__vxB=JSON.parse(el.textContent));
 var lista;
 if(eixo==='marca'){
  var gs0=mark['grupo']||[];
  var MAPG={material:['filamento','resina','po-plastico','po-metalico','pellet'],'peca-consumivel':['peca-consumivel'],'peca-reposicao':['peca-reposicao'],acessorio:['equipamento']};
  var permit=null,tms=mark['tipomat']||[];
  if(tms.length){permit={};
   tms.forEach(function(tp){(PT[tp]||[]).forEach(function(g){if(g.k==='marca')g.o.forEach(function(o){permit[o.t]=1})})})}
  else if(gs0.length){permit={};
   gs0.forEach(function(gk){(MAPG[gk]||[]).forEach(function(tp){
    (PT[tp]||[]).forEach(function(g){if(g.k==='marca')g.o.forEach(function(o){permit[o.t]=1})})})})}
  lista=(B['marca']||[]).filter(function(o){return !permit||permit[o.t]})}
 else lista=(B['maquina']||[]).filter(function(o){return !tec||o.tec===tec});
 var alvo=grid.parentElement,cx=document.querySelector('[data-vxtipos]');
 if(!cx){cx=document.createElement('div');cx.setAttribute('data-vxtipos','');alvo.insertBefore(cx,grid)}
 cx.hidden=false;grid.hidden=true;cx.className='vxh__grade vxblocos';
 cx.innerHTML=lista.map(function(o){
  return '<button type="button" class="vxh__card" data-vxmaq="'+o.t+'">'+
   (o.img?'<div class="vxh__card-img"><img src="'+o.img+'" alt="'+o.n+'" loading="lazy" width="900" height="675"></div>':'')+
   '<div class="vxh__card-tx vxh__card-info"><h3 class="vxh__card-h vxh__card-t">'+o.n+'</h3>'+
   '<p class="vxh__card-p">Ver o que temos para esta máquina</p>'+
   '<span class="vxh__card-btn">Ver o que temos</span></div></button>'}).join('')}
function colunaTec(){
 var li='';
 li+='<li class="facets__item list-menu__item"><label class="facets__label facet-checkbox" for="vxtec-todas">'+
  '<input type="checkbox" id="vxtec-todas" data-vxtec=""'+(tec?'':' checked')+'>'+CHECK+
  '<span class="facet-checkbox__text"><span class="facet-checkbox__text-label">Todas</span></span></label></li>';
 var el=document.querySelector('[data-vxblocos]');
 var B=el?(window.__vxB||(window.__vxB=JSON.parse(el.textContent))):{};
 TECS.forEach(function(x){
  var n=(B['maquina']||[]).filter(function(o){return o.tec===x.t}).length;
  if(!n)return;
  li+='<li class="facets__item list-menu__item"><label class="facets__label facet-checkbox" for="vxtec-'+x.t+'">'+
   '<input type="checkbox" id="vxtec-'+x.t+'" data-vxtec="'+x.t+'"'+(tec===x.t?' checked':'')+'>'+CHECK+
   '<span class="facet-checkbox__text"><span class="facet-checkbox__text-label">'+x.n+'</span> ('+n+')</span></label></li>'});
 boxT.innerHTML=bloco('Tecnologia de máquina',li);boxG.innerHTML=''}
var SIGLA={msla:'mSLA',fdm:'FDM',sls:'SLS',slm:'SLM',dlp:'DLP',mjf:'MJF',saf:'SAF',esd:'ESD',abs:'ABS',asa:'ASA',pla:'PLA',petg:'PETG',pet:'PET',pp:'PP',pc:'PC',pa:'PA',pa11:'PA11',pa12:'PA12',pps:'PPS',psu:'PSU',pes:'PES',ppsu:'PPSU',peek:'PEEK',pekk:'PEKK',pei:'PEI',tpu:'TPU',tpa:'TPA',tpc:'TPC',tpi:'TPI',plla:'PLLA',hips:'HIPS',pctg:'PCTG',pvdf:'PVDF',bvoh:'BVOH',cf:'CF',gf:'GF',po:'Pó',mm:'mm',kg:'kg',nm:'nm',iam:'i-AM',isquared:'iSQUARED'};
function vxRot(t,pre){
 var c=(pre&&t.indexOf(pre+'-')===0)?t.slice(pre.length+1):t;
 var ps=c.split('-'),out=[];
 for(var i=0;i<ps.length;i++){var w=ps[i];
  if(!w)continue;
  if(SIGLA[w]){out.push(SIGLA[w]);continue}
  if(/^\d/.test(w)){out.push(w);continue}
  out.push(w.charAt(0).toUpperCase()+w.slice(1));}
 return out.join(' ')||t;
}
var VXNUT={};
var VXPROIB={cor:1,embalagem:1,preco:1};
function vxNutre(tp){
 if(!tp||VXNUT[tp]||!PT[tp]||!grid)return;
 var gs=PT[tp],tem={},prefG={};
 for(var i=0;i<gs.length;i++)for(var j=0;j<gs[i].o.length;j++){
  var t=gs[i].o[j].t;tem[t]=1;
  var k=t.indexOf('-')>0?t.slice(0,t.indexOf('-')):t;
  prefG[k]=prefG[k]||{};prefG[k][i]=(prefG[k][i]||0)+1;}
 var dono={};
 for(var k in prefG){var b=-1,n=-1;for(var gi in prefG[k])if(prefG[k][gi]>n){n=prefG[k][gi];b=+gi}dono[k]=b}
 var reais={},li=itens();
 for(var i=0;i<li.length;i++){var ts=tags(li[i]);
  for(var j=0;j<ts.length;j++){var t=(ts[j]||'').trim();if(t)reais[t]=1}}
 var ec=document.querySelector('[data-vxtagscol]');
 if(ec){try{var tc=JSON.parse(ec.textContent)||[];
  for(var i=0;i<tc.length;i++){var t=String(tc[i]).trim();if(t)reais[t]=1}}catch(e){}}
 var novos={};
 for(var t in reais){
  if(tem[t]||t.indexOf('-')<1)continue;
  var pre=t.slice(0,t.indexOf('-'));
  if(VXPROIB[pre])continue;
  var gi=dono[pre];
  if(gi===undefined){
   if(!novos[pre]){novos[pre]={k:'auto-'+pre,r:vxRot(pre,''),o:[],vxauto:1};gs.push(novos[pre])}
   novos[pre].o.push({t:t,n:vxRot(t,pre),vxauto:1});
  }else{gs[gi].o.push({t:t,n:vxRot(t,pre),vxauto:1});}
  tem[t]=1;}
 VXNUT[tp]=1;
}
function grupos(){
 boxG.innerHTML='';
 if(eixo==='tipo'&&tipo)vxNutre(tipo);
 if(eixo==='marca'&&!(mark['marca']||[]).length){
  var FX0=[{t:'',n:'Todos'},{t:'material',n:'Materiais'},{t:'peca-consumivel',n:'Peças Consumíveis'},{t:'acessorio',n:'Acessórios'},{t:'peca-reposicao',n:'Peças de Reposição'}];
  var s0=mark['grupo']||[],l0='';
  FX0.forEach(function(f){
   var MAPG0={material:['filamento','resina','po-plastico','po-metalico','pellet'],'peca-consumivel':['peca-consumivel'],'peca-reposicao':['peca-reposicao'],acessorio:['equipamento']};
   var elb0=document.querySelector('[data-vxblocos]');
   var B0=elb0?(window.__vxB||(window.__vxB=JSON.parse(elb0.textContent))):{};
   if(!f.t){l0+=caixa('vxf-grupo-todos','','grupo','Todos',(B0['marca']||[]).length,!s0.length);return}
   var pm={};(MAPG0[f.t]||[]).forEach(function(tp){(PT[tp]||[]).forEach(function(g){if(g.k==='marca')g.o.forEach(function(o){pm[o.t]=1})})});
   var n=(B0['marca']||[]).filter(function(o){return pm[o.t]}).length;
   l0+=caixa('vxf-grupo-'+f.t,f.t,'grupo',f.n,n,s0.indexOf(f.t)>=0)});
  boxT.innerHTML=bloco('Tipo de produto',l0);
  var hsub='';
  if(s0.indexOf('material')>=0){
   var TM=[{t:'filamento',n:'Filamentos'},{t:'resina',n:'Resinas'},{t:'po-plastico',n:'Pós para SLS'},{t:'po-metalico',n:'Pós metálicos'},{t:'pellet',n:'Pellets'}];
   var sm=mark['tipomat']||[],lm='';
   var elb1=document.querySelector('[data-vxblocos]');
   var B1=elb1?(window.__vxB||(window.__vxB=JSON.parse(elb1.textContent))):{};
   TM.forEach(function(x){
    var pm={};(PT[x.t]||[]).forEach(function(g){if(g.k==='marca')g.o.forEach(function(o){pm[o.t]=1})});
    var n=(B1['marca']||[]).filter(function(o){return pm[o.t]}).length;
    lm+=caixa('vxf-tipomat-'+x.t,x.t,'tipomat',x.n,n,sm.indexOf(x.t)>=0)});
   hsub=bloco('Tipo de material',lm)}
  boxG.innerHTML=hsub;blocosMaquina();return}
 if(eixo==='marca'){
  var cxm=document.querySelector('[data-vxtipos]');if(cxm){cxm.hidden=true;cxm.innerHTML=''}
  if(grid)grid.hidden=false;
  boxT.innerHTML='';
  var FXM=[{t:'material',n:'Materiais'},{t:'peca-consumivel',n:'Peças Consumíveis'},{t:'acessorio',n:'Acessórios'},{t:'peca-reposicao',n:'Peças de Reposição'}];
  var selm2=mark['grupo']||[],lim='';
  FXM.forEach(function(f){
   var n=0;itens().forEach(function(x){var t=tags(x);if(bateGrupo(t,f.t)&&passa(t,'grupo'))n++});
   lim+=caixa('vxf-grupo-'+f.t,f.t,'grupo',f.n,n,selm2.indexOf(f.t)>=0)});
  var mkc=(mark['marca']||[])[0];
  var hsub2='',tpm2=[];
  var gsel2=mark['grupo']||[];
  if(gsel2.indexOf('material')>=0){
   var TM2=[{t:'filamento',n:'Filamentos'},{t:'resina',n:'Resinas'},{t:'po-plastico',n:'Pós para SLS'},{t:'po-metalico',n:'Pós metálicos'},{t:'pellet',n:'Pellets'}];
   var sm2=mark['tipomat']||[],lm2='';
   TM2.forEach(function(x){
    var tem2=(PT[x.t]||[]).some(function(g){return g.k==='marca'&&g.o.some(function(o){return o.t===mkc})});
    if(!tem2)return;
    var n=0;itens().forEach(function(y){var t=tags(y);if(tem(t,x.t)&&tem(t,mkc))n++});
    lm2+=caixa('vxf-tipomat-'+x.t,x.t,'tipomat',x.n,n,sm2.indexOf(x.t)>=0)});
   if(lm2)hsub2=bloco('Tipo de material',lm2);
   tpm2=sm2.slice()}
  else if(gsel2.length){
   var MG2={'peca-consumivel':['peca-consumivel'],'peca-reposicao':['peca-reposicao'],acessorio:['equipamento']};
   gsel2.forEach(function(g){(MG2[g]||[]).forEach(function(x){if(tpm2.indexOf(x)<0)tpm2.push(x)})})}
  var og=[],pg={};
  tpm2.forEach(function(tp){(PT[tp]||[]).forEach(function(g){
   if(g.k==='marca'||g.k==='maquina')return;
   if(!pg[g.k]){pg[g.k]={r:g.r,o:[],vis:{}};og.push(g.k)}
   g.o.forEach(function(o){if(!pg[g.k].vis[o.t]){pg[g.k].vis[o.t]=1;pg[g.k].o.push(o)}})})});
  var hcm='';
  og.forEach(function(k){
   var g=pg[k],sel=mark['g_'+k]||[],lin='';
   g.o.forEach(function(o){
    var n=0;itens().forEach(function(x){var t=tags(x);if(tem(t,o.t)&&passa(t,'g_'+k))n++});
    lin+=caixa('vxf-'+k+'-'+o.t,o.t,'g_'+k,o.n,n,sel.indexOf(o.t)>=0)});
   hcm+=bloco(g.r,lin)});
  boxG.innerHTML=bloco('Tipo de produto',lim)+hsub2+hcm;
  return}
 if(eixo==='maquina'&&!(mark['maquina']||[]).length){colunaTec();blocosMaquina();return}
 if(eixo==='maquina'){
  colunaTec();
  var cxx=document.querySelector('[data-vxtipos]');if(cxx){cxx.hidden=true;cxx.innerHTML=''}
  if(grid)grid.hidden=false;
  var FX=[{t:'material',n:'Materiais'},{t:'peca-consumivel',n:'Peças Consumíveis'},{t:'acessorio',n:'Acessórios'},{t:'peca-reposicao',n:'Peças de Reposição'}];
  var MAT=['filamento','resina','po-plastico','po-metalico','pellet'];
  function bate(t,k){
   if(k==='material')return MAT.some(function(x){return tem(t,x)});
   if(k==='acessorio')return t.some(function(x){return x.indexOf('acessorio')===0});
   return tem(t,k)}
  var sel=mark['grupo']||[],li='';
  FX.forEach(function(f){
   var n=0;itens().forEach(function(x){var t=tags(x);if(bate(t,f.t)&&passa(t,'grupo'))n++});
   li+=caixa('vxf-grupo-'+f.t,f.t,'grupo',f.n,n,sel.indexOf(f.t)>=0)});
  var hm='';
  var elb=document.querySelector('[data-vxblocos]');
  var Bm=elb?(window.__vxB||(window.__vxB=JSON.parse(elb.textContent))):{};
  var MB=(Bm['maquina']||[]).filter(function(o){return !tec||o.tec===tec});
  var selm=mark['maquina']||[];
  MB.forEach(function(o){
   var n=0;itens().forEach(function(x){var t=tags(x);if(tem(t,o.t)&&passa(t,'maquina'))n++});
   hm+=caixa('vxf-maq-'+o.t,o.t,'maquina',o.n,n,selm.indexOf(o.t)>=0)});
  var hc='';
  var gsel=mark['grupo']||[];
  var TECMAT={'equipamento-filamento':['filamento'],'equipamento-resina':['resina'],'equipamento-resina-dental':['resina'],
   'equipamento-sls':['po-plastico'],'equipamento-metal':['po-metalico'],'equipamento-pellet':['pellet'],
   'equipamento-injecao':['pellet'],'equipamento-acabamento-sls-fdm':[]};
  var MATTEC=(TECMAT[tec]||['filamento','resina','po-plastico','po-metalico','pellet']);
  var mapa={material:MATTEC,'peca-consumivel':['peca-consumivel'],'peca-reposicao':['peca-reposicao'],acessorio:[]};
  var fontes=(!gsel.length||gsel.indexOf('material')>=0)?MATTEC.slice():[];
  var ordemG=[],porG={};
  fontes.forEach(function(tp){
   (PT[tp]||[]).forEach(function(g){
    if(g.k==='marca'||g.k==='maquina')return;
    if(!porG[g.k]){porG[g.k]={r:g.r,o:[],vis:{}};ordemG.push(g.k)}
    g.o.forEach(function(o){if(!porG[g.k].vis[o.t]){porG[g.k].vis[o.t]=1;porG[g.k].o.push(o)}})})});
  ordemG.forEach(function(k){
   var g=porG[k],sel=mark['g_'+k]||[],lin='',vivos=0;
   g.o.forEach(function(o){
    var n=0;itens().forEach(function(x){var t=tags(x);if(tem(t,o.t)&&passa(t,'g_'+k))n++});
    vivos++;lin+=caixa('vxf-'+k+'-'+o.t,o.t,'g_'+k,o.n,n,sel.indexOf(o.t)>=0)});
   if(vivos)hc+=bloco(g.r,lin)});
  boxG.innerHTML=bloco('Tipo de produto',li)+hc;
  return}
 if(!tipo)return;
 var gs=PT[tipo]||[],h='',topo='',fim='',fmq='';
 gs.forEach(function(g){
  if(!g.o||!g.o.length)return;
  var sel=mark[g.k]||[],li='';
  g.o.forEach(function(o){li+=caixa('vxf-'+g.k+'-'+o.t,o.t,g.k,o.n,conta(g.k,o.t),sel.indexOf(o.t)>=0)});
  if(g.k===eixo)topo+=bloco(g.r,li);else if(g.k==='marca')fim+=bloco(g.r,li);else if(g.k==='maquina')fmq+=bloco(g.r,li);else h+=bloco(g.r,li)});
 boxG.innerHTML=topo+fim+h+fmq}
function blocos(){
 var el=document.querySelector('[data-vxblocos]');if(!el||!grid)return;
 var B=window.__vxB||(window.__vxB=JSON.parse(el.textContent));
 var alvo=grid.parentElement,cx=document.querySelector('[data-vxtipos]');
 if(!cx){cx=document.createElement('div');cx.setAttribute('data-vxtipos','');alvo.insertBefore(cx,grid)}
 var mostra=!tipo&&location.pathname!=='/collections/promocao';
 cx.hidden=!mostra;grid.hidden=mostra;
 if(!mostra){cx.innerHTML='';return}
 var lista=B['tipo']||[];
 cx.className='vxh__grade vxblocos';
 cx.innerHTML=lista.map(function(o){
  return '<button type="button" class="vxh__card" data-vxtipo="'+o.t+'">'+
   (o.img?'<div class="vxh__card-img"><img src="'+o.img+'" alt="'+o.n+'" loading="lazy" width="900" height="675"></div>':'')+
   '<div class="vxh__card-tx"><h3 class="vxh__card-h">'+o.n+'</h3><p class="vxh__card-p">'+(o.p||'Ver o catálogo')+'</p><span class="vxh__card-btn">Ver o que temos</span></div></button>'}).join('')}
function pinta(){
 var n=0;
 itens().forEach(function(li){var ok=passa(tags(li),null);li.classList.toggle('vxoff',!ok);if(ok)n++});
 var c=document.getElementById('ProductCountDesktop');
 if(c)c.textContent=n+(n===1?' produto':' produtos')}
function url(){
 var q=[];
 for(var k in mark)(mark[k]||[]).forEach(function(t){q.push(t)});
 var u=location.pathname,nova=q.length?u+'?f='+q.join(','):u;
 if(nova!==location.pathname+location.search)history.replaceState(null,'',nova)}
var colMaq='';
var ORDEM=['filamento','resina','po-plastico','po-metalico','pellet','peca-consumivel','acessorio','peca-reposicao','equipamento'];
function ordemDe(t){
 for(var i=0;i<ORDEM.length;i++){
  var k=ORDEM[i];
  if(k==='acessorio'){if(t.some(function(x){return x.indexOf('acessorio')===0}))return i;continue}
  if(tem(t,k))return i}
 return ORDEM.length}
function precoDe(li){
 var e=li.querySelector('[data-vxpc-brl]');
 if(!e)return 1e12;
 var x=(e.textContent||'').replace(/[^0-9,.]/g,'').replace(/\./g,'').replace(',','.');
 var n=parseFloat(x);
 return isNaN(n)||!n?1e12:n}
function ordenaMaquina(){
 if(!grid)return;
 var xs=itens();
 if(!xs.length)return;
 xs.map(function(li,i){return{li:li,o:ordemDe(tags(li)),p:precoDe(li),i:i}})
  .sort(function(a,b){return a.o-b.o||a.p-b.p||a.i-b.i})
  .forEach(function(x){grid.appendChild(x.li)})}
function tiposDaMaquina(){
 var pres={};
 itens().forEach(function(li){tags(li).forEach(function(x){if(TIPOS.some(function(o){return o.t===x}))pres[x]=(pres[x]||0)+1})});
 var h=linkTipo('','Todos',!tipo);
 TIPOS.forEach(function(o){h+=caixa('vxf-tipo-'+o.t,o.t,'tipo2',o.n,pres[o.t]||0,tipo===o.t)});
 boxT.innerHTML=bloco('Tipo de produto',h)}
function rotuloDe(t){
 if(colMaq||true){
  var r=null;
  (TIPOS||[]).forEach(function(o){if(o.t===t)r=o.n});
  if(r)return r;
  for(var k in PT)(PT[k]||[]).forEach(function(g){g.o.forEach(function(o){if(o.t===t&&!r)r=o.n})});
  TECS.forEach(function(x){if(x.t===t&&!r)r=x.n});
  return r||t}}
var PESO={marca:0,categoria:1,tipo:2};
var selAberto='',espelhando=false;
function pesoDe(r){
 var x=(r||'').toLowerCase();
 if(x.indexOf('marca')>=0)return 0;
 if(x.indexOf('categoria')>=0)return 1;
 if(x.indexOf('tipo')>=0)return 2;
 return 3}
function podaZeros(){
 [].forEach.call(document.querySelectorAll('[data-vxnav] details.vxg'),function(d){
  var ins=[].slice.call(d.querySelectorAll('input[data-gr=maquina][data-tg]'));
  if(!ins.length)return;
  var mortos=[];
  ins.forEach(function(i){
   if(i.checked)return;
   var l=i.closest('label'),li=i.closest('li');if(!l||!li)return;
   var m=/\((\d+)\)\s*$/.exec(l.textContent.trim());
   if(m&&m[1]==='0')mortos.push(li)});
  if(mortos.length&&mortos.length<ins.length)mortos.forEach(function(li){li.remove()})})}
function campos(){
 var b=barra();if(!b)return;
 var v=b.querySelector('[data-vxcampos]');if(v)v.remove();
 var d0=b.querySelector('.vxdiv');if(d0)d0.remove();
 var blocos=[].slice.call(document.querySelectorAll('[data-vxnav] details.vxg')),lista=[];
 blocos.forEach(function(d){
  var e=d.querySelector('.facets__summary-label'),rot=e?e.textContent.trim():'';
  var ins=[].slice.call(d.querySelectorAll('input[type=checkbox][data-gr][data-tg]'));
  if(!rot||!ins.length)return;
  lista.push({r:rot,i:ins,p:pesoDe(rot)})});
 if(!lista.length)return;
 lista.forEach(function(x,i){x.o=i});
 lista.sort(function(a,c){return a.p-c.p||a.o-c.o});
 var h='';
 lista.forEach(function(x,i){
  var n=x.i.filter(function(z){return z.checked}).length;
  var op='';
  x.i.forEach(function(z){
   var lb=z.closest('label'),t=lb?lb.textContent.trim().replace(/\s+/g,' '):z.getAttribute('data-tg');
   op+='<li class="vxsel__i"><label class="vxsel__l"><input type="checkbox" class="vxsel__c"'+(z.checked?' checked':'')+
    ' data-vxgr="'+z.getAttribute('data-gr')+'" data-vxtg="'+z.getAttribute('data-tg')+'"><span>'+t+'</span></label></li>'});
  h+='<details class="vxsel'+(n?' is-on':'')+'" data-vxsel="'+x.r+'"'+(selAberto===x.r?' open':'')+'>'+
   '<summary class="vxsel__b"><span class="vxsel__r">'+x.r+(n?' <em>('+n+')</em>':'')+'</span><i class="vxsel__seta" aria-hidden="true"></i></summary>'+
   '<div class="vxsel__p"><ul class="vxsel__u list-unstyled" role="list">'+op+'</ul></div></details>'});
 var sep=document.createElement('span');sep.className='vxdiv';sep.setAttribute('aria-hidden','true');
 var box=document.createElement('div');box.className='vxcampos';box.setAttribute('data-vxcampos','');box.innerHTML=h;
 b.appendChild(sep);b.appendChild(box)}
function chips(){
 barra();
 var alvo=document.querySelector('[data-vxchips]');
 if(!alvo)return;
 var itens=[];
 if(tipo)itens.push({g:'tipo',t:tipo,n:rotuloDe(tipo)});
 if(tec)itens.push({g:'tec',t:tec,n:(function(){var r=tec;TECS.forEach(function(x){if(x.t===tec)r=x.n});return r})()});
 var ROTG={material:'Materiais','peca-consumivel':'Peças Consumíveis',acessorio:'Acessórios','peca-reposicao':'Peças de Reposição'};
 for(var k in mark)(mark[k]||[]).forEach(function(t){itens.push({g:k,t:t,n:(k==='grupo'?ROTG[t]||t:rotuloDe(t))})});
 var visto={},limpos=[];
 itens.forEach(function(x){var k=x.t+'|'+x.n;if(visto[k])return;visto[k]=1;limpos.push(x)});
 var porNome={};limpos=limpos.filter(function(x){if(porNome[x.n])return false;porNome[x.n]=1;return true});
 itens=limpos;
 if(!itens.length){alvo.hidden=true;alvo.innerHTML='';return}
 alvo.hidden=false;
 alvo.innerHTML='<span class="vxchips__r">Filtrando por</span><div class="vxchips__lista">'+
  itens.map(function(x){
   return '<button type="button" class="vxchips__c" data-vxtira="'+x.g+'" data-vxtiratg="'+x.t+'">'+x.n+
    '<span class="vxchips__x" aria-hidden="true">×</span></button>'}).join('')+
  (itens.length>1?'<button type="button" class="vxchips__limpa" data-vxlimpa>Limpar tudo</button>':'')+'</div>'}
function desenha(){
 eixos();ordenaMaquina();
 if(colMaq){pinta();tiposDaMaquina();boxG.innerHTML='';chips();campos();url();return}
 pinta();if(eixo==='tipo')listaTipos();grupos();if(eixo==='tipo')blocos();podaZeros();chips();campos();url()}
async function tudo(){
 if(carregado||!grid)return;carregado=true;
 var vistos={};itens().forEach(function(li){var a=li.querySelector('a[href]');if(a)vistos[a.getAttribute('href').split('?')[0]]=1});
 for(var p=2;p<41;p++){
  try{
   var r=await fetch(location.pathname+'?page='+p);if(!r.ok)break;
   var d=new DOMParser().parseFromString(await r.text(),'text/html');
   var li=d.querySelectorAll('.product-grid>li'),novos=0;
   if(!li.length)break;
   for(var i=0;i<li.length;i++){var a=li[i].querySelector('a[href]');if(!a)continue;
    var h=a.getAttribute('href').split('?')[0];if(vistos[h])continue;vistos[h]=1;
    grid.appendChild(document.importNode(li[i],true));novos++}
   if(!novos)break}catch(e){break}}}
document.addEventListener('click',function(e){
 var b=e.target.closest&&e.target.closest('.vxh__card[data-vxtipo]');
 if(b){e.preventDefault();location.href='/collections/'+b.getAttribute('data-vxtipo')+qsTags()}});

document.addEventListener('click',function(e){
 var mq=e.target.closest&&e.target.closest('[data-vxmaq]');
 if(mq&&eixo==='marca'){mark['marca']=[mq.getAttribute('data-vxmaq')];desenha();return}
 if(mq){var tt=mq.getAttribute('data-vxmaq');
  mark['maquina']=[tt];
  var el0=document.querySelector('[data-vxblocos]');
  if(el0){var B0=window.__vxB||(window.__vxB=JSON.parse(el0.textContent));
   (B0['maquina']||[]).forEach(function(o){if(o.t===tt&&o.tec)tec=o.tec})}
  desenha();return}
 var lp=e.target.closest&&e.target.closest('[data-vxlimpa]');
 if(lp){mark={};tec='';if(colMaq)tipo='';desenha();return}
 var tr=e.target.closest&&e.target.closest('[data-vxtira]');
 if(tr){var g=tr.getAttribute('data-vxtira'),t=tr.getAttribute('data-vxtiratg');
  if(g==='tipo'){if(colMaq)tipo='';else{location.href='/collections/all'+qsTags();return}}
  else if(g==='tec')tec='';
  else mark[g]=(mark[g]||[]).filter(function(y){return y!==t});
  desenha();return}
 var x=e.target.closest&&e.target.closest('[data-eixo],[data-vxeixo]');
 if(x){
  var novo=x.getAttribute('data-eixo')||x.getAttribute('data-vxeixo')||'';
  if(novo==='produto')novo='tipo';
  if(!novo)return;
  if(location.pathname!=='/collections/all'){location.href='/collections/all?e='+novo;return}
  mark={};tipo='';tec='';
  eixo=novo;
  var cxz=document.querySelector('[data-vxtipos]');if(cxz){cxz.hidden=true;cxz.innerHTML=''}
  if(grid)grid.hidden=false;
  desenha();
  return}
 var d=e.target.closest&&e.target.closest('.vxbar__g');
 [].forEach.call(document.querySelectorAll('.vxbar__g[open]'),function(x){if(x!==d)x.open=false})},true);
document.addEventListener('click',function(e){
 var sm=e.target.closest&&e.target.closest('.vxsel__b');
 if(sm){var d=sm.parentElement;
  selAberto=d.hasAttribute('open')?'':d.getAttribute('data-vxsel');
  [].forEach.call(document.querySelectorAll('.vxsel[open]'),function(o){if(o!==d)o.removeAttribute('open')});
  return}
 if(espelhando)return;
 if(e.target.closest&&e.target.closest('[data-vxcampos]'))return;
 if(selAberto){selAberto='';[].forEach.call(document.querySelectorAll('.vxsel[open]'),function(o){o.removeAttribute('open')})}
});
document.addEventListener('change',function(e){
 if(e.target.classList&&e.target.classList.contains('vxsel__c')){
  var g=e.target.getAttribute('data-vxgr'),t=e.target.getAttribute('data-vxtg');
  var o=document.querySelector('[data-vxnav] input[data-gr="'+g+'"][data-tg="'+t+'"]');
  if(o&&o.checked!==e.target.checked){espelhando=true;o.click();espelhando=false}
  return}
 var i=e.target;
 if(i.matches&&i.matches('[data-vxtec]')){tec=i.getAttribute('data-vxtec');desenha();return}if(!i.matches||!i.matches('[data-tg],[data-todos],[data-gr="tipo"]'))return;
 var g=i.getAttribute('data-gr'),t=i.getAttribute('data-tg');
 if(g==='tipo2'){tipo=i.checked?t:'';desenha();return}
 if(g==='grupo'&&!t){mark['grupo']=[];mark['tipomat']=[];desenha();return}
 if(g==='grupo'){mark['grupo']=i.checked?[t]:[];if(t!=='material')mark['tipomat']=[];desenha();return}
 if(g==='tipomat'){mark['tipomat']=i.checked?[t]:[];desenha();return}
 if(!g||g==='tipo')return;
 if(i.getAttribute('data-todos')){mark[g]=[];desenha();return}
 mark[g]=mark[g]||[];
 if(i.checked){if(mark[g].indexOf(t)<0)mark[g].push(t)}
 else mark[g]=mark[g].filter(function(x){return x!==t});
 desenha()});
(async function(){
 var q=new URLSearchParams(location.search);
 var f=(q.get('f')||'').split(',').filter(Boolean);
 var ex=q.get('e')||'';
 var h=location.pathname.replace(/^\/collections\//,'').split('/')[0];
 if(ex==='marca'||ex==='maquina'||ex==='tipo')eixo=ex;
 if(ex&&f.length){
  if(ex==='marca'){var mm=f.filter(function(x){return x.indexOf('marca-')===0});if(mm.length)mark['marca']=[mm[0]]}
  if(ex==='maquina'){var qq=f.filter(function(x){return x.indexOf('maquina-')===0||x.indexOf('marca-')===0});
   if(qq.length){mark['maquina']=[qq[0]];
    var el7=document.querySelector('[data-vxblocos]');
    if(el7){var B7=window.__vxB||(window.__vxB=JSON.parse(el7.textContent));
     (B7['maquina']||[]).forEach(function(o){if(o.t===qq[0]&&o.tec)tec=o.tec})}}}}
 if(h.indexOf('maquina-')===0){
  eixo='maquina';mark['maquina']=[h];
  var el9=document.querySelector('[data-vxblocos]');
  if(el9){var B9=window.__vxB||(window.__vxB=JSON.parse(el9.textContent));
   (B9['maquina']||[]).forEach(function(o){if(o.t===h&&o.tec)tec=o.tec})}}
 else if(h.indexOf('marca-')===0){eixo='marca';mark['marca']=[h]}
 if(TIPOS.some(function(o){return o.t===h})){tipo=h;
  if(ex==='marca'||ex==='maquina')mark['grupo']=['material'];
  if(ex==='marca'&&['filamento','resina','po-plastico','po-metalico','pellet'].indexOf(h)>=0)mark['tipomat']=[h];}
 if(!tipo&&eixo==='tipo'&&h&&h!=='all')for(var k in PT)(PT[k]||[]).forEach(function(g){
  if(g.o.some(function(o){return o.t===h})){if(!tipo)tipo=k;mark[g.k]=mark[g.k]||[];if(mark[g.k].indexOf(h)<0)mark[g.k].push(h)}});
 if(!ex||ex==='tipo')f.forEach(function(t){
  if(TIPOS.some(function(o){return o.t===t}))return;
  (PT[tipo]||[]).forEach(function(g){
   if(g.o.some(function(o){return o.t===t})){mark[g.k]=mark[g.k]||[];if(mark[g.k].indexOf(t)<0)mark[g.k].push(t);
    var kk='g_'+g.k;mark[kk]=mark[kk]||[];if(mark[kk].indexOf(t)<0)mark[kk].push(t)}})});
 desenha();
 try{await tudo()}catch(e){}
 desenha();
 try{carregaIdx(function(){desenha()})}catch(e){}})();
})();
